export function validateCreateUserForm({
  username,
  password,
  validatePasswordPolicyFn,
}) {
  if (!username || !password) return '用户名和密码必填';
  const policyError = validatePasswordPolicyFn(password, username);
  if (policyError) return policyError;
  return '';
}

export function buildUserUpdatePayload({
  name,
  email,
  role,
}) {
  return {
    name,
    email,
    role,
    permissionBasis: 'user',
  };
}

export function validateEditUserForm() {
  return '';
}

export function validateResetPasswordForm({
  newPassword,
  confirmPassword,
  username,
  validatePasswordPolicyFn,
}) {
  const policyError = validatePasswordPolicyFn(newPassword, username);
  if (policyError) return policyError;
  if (newPassword !== confirmPassword) return '两次密码不一致';
  return '';
}
